import React, { useEffect } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';

function MyApp({ props }) {
    const { enqueueSnackbar } = useSnackbar();
    // variant could be success, error, warning, info, or default
    useEffect(() => {
        const message = props.message
        const variant = props.variant || "default"
        enqueueSnackbar(message, { variant });
    }, []);
    return <></>
}
export default function SnackBar(props) {
    return (
        <SnackbarProvider maxSnack={3}>
            <MyApp props={props} />
        </SnackbarProvider>
    );
}